import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import type { SelectOption } from '@/components/ui/select';
import { DetailsSelect } from '@/features/estates-property/components/details-select';

export const FieldSelect = <T extends FieldValues>({
  label,
  name,
  methods,
  options = [],
  required = true,
  type = 'string',
}: {
  name: Path<T>;
  label: string;
  required?: boolean;
  methods: UseFormReturn<T>;
  options?: SelectOption[];
  type?: 'string' | 'number';
}) => {
  const handleChange = (onChange: (val?: string | number) => void) => {
    return (ev: { target: { value: string } }) => {
      const value = ev.target.value;
      if (type === 'number') {
        if (value.trim().length === 0 || Number.isNaN(Number(value))) {
          onChange('');
        } else {
          onChange(Number(value));
        }
      } else {
        onChange(value);
      }
    };
  };

  return (
    <Controller
      {...methods}
      name={name}
      render={({ field: { onChange, value, ...field }, fieldState }) => (
        <DetailsSelect
          {...field}
          label={`${label}${required ? '*' : ''}`}
          value={String(value ?? '')}
          options={options}
          className="shadow-sm"
          onChange={handleChange(onChange)}
          errors={fieldState.error?.message ? [fieldState.error.message] : undefined}
        />
      )}
    />
  );
};
